import { Link } from 'react-router-dom';
import { VERTICALS, verticalCopy } from '@/lib/verticals';
import { useT, useRaw } from '@/lib/i18n';

export const Footer = () => {
  const t = useT();
  const raw = useRaw();
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative mt-10 overflow-hidden bg-[#0A0E1A] text-white"
    >
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div
          className="absolute -left-24 top-[-30%] h-[420px] w-[420px] rounded-full opacity-40 blur-3xl"
          style={{
            background:
              'radial-gradient(closest-side, rgba(139,92,246,0.35), transparent 70%)',
          }}
        />
        <div
          className="absolute right-[-6%] bottom-[-30%] h-[420px] w-[420px] rounded-full opacity-40 blur-3xl"
          style={{
            background:
              'radial-gradient(closest-side, rgba(16,185,129,0.28), transparent 70%)',
          }}
        />
      </div>

      <div className="om-container relative py-16 md:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <img
                src="/brand/logo-mark-white.png"
                alt="OpenMeta"
                className="h-9 w-9"
                width="36"
                height="36"
              />
              <span className="text-[19px] font-extrabold tracking-tight">OpenMeta</span>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-white/70">
              {t('footer.tagline')}
            </p>
            <div className="mt-6 flex items-center gap-2">
              {VERTICALS.map((v) => {
                const vc = verticalCopy(raw, v.code);
                return (
                  <span
                    key={v.code}
                    aria-label={vc.label}
                    title={vc.label}
                    className="h-2.5 w-8 rounded-full"
                    style={{ background: v.color, opacity: 0.9 }}
                  />
                );
              })}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-semibold uppercase tracking-wider text-white/50">
              {t('footer.section_universe')}
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              {VERTICALS.map((v) => {
                const vc = verticalCopy(raw, v.code);
                return (
                  <li key={v.code}>
                    <Link
                      to={v.path}
                      className="inline-flex items-center gap-2 text-white/80 transition-colors hover:text-white"
                      data-testid={`footer-vertical-${v.code}`}
                    >
                      <span className="h-1.5 w-1.5 rounded-full" style={{ background: v.color }} />
                      {vc.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-semibold uppercase tracking-wider text-white/50">
              {t('footer.section_product')}
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/applications" className="text-white/80 hover:text-white" data-testid="footer-link-applications">{t('footer.product_applications')}</Link></li>
              <li><Link to="/generateur" className="text-white/80 hover:text-white" data-testid="footer-link-generateur">{t('footer.product_generator')}</Link></li>
              <li><Link to="/tarifs" className="text-white/80 hover:text-white" data-testid="footer-link-tarifs">{t('footer.product_pricing')}</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-white" data-testid="footer-link-contact">{t('footer.product_contact')}</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-semibold uppercase tracking-wider text-white/50">
              {t('footer.section_info')}
            </div>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/mentions-legales" className="text-white/80 hover:text-white" data-testid="footer-link-legal">{t('footer.info_legal')}</Link></li>
              <li><Link to="/confidentialite" className="text-white/80 hover:text-white" data-testid="footer-link-privacy">{t('footer.info_privacy')}</Link></li>
              <li><Link to="/conditions-utilisation" className="text-white/80 hover:text-white" data-testid="footer-link-terms">{t('footer.info_terms')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs text-white/50 sm:flex-row sm:items-center">
          <div data-testid="footer-copyright">{t('footer.copyright', { year })}</div>
          <div className="inline-flex items-center gap-2">
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-emerald-400" />
            {t('footer.slogan')}
          </div>
        </div>
      </div>
    </footer>
  );
};
